<template>
  <div class="animated fadeIn" ref="mapdiv">
    <div
      v-if="
        this.g_selected.length > 0 ||
          this.o_selected.length > 0 ||
          this.t_selected.length > 0
      "
      class="mb-5"
    >
      <b-button
        v-for="(t, index) in g_selected"
        :key="index"
        size="sm"
        class="m-1"
        variant="outline-primary"
        @click="deselect(g_selected, i)"
        ><i class="fa fa-close"></i> {{ t }}</b-button
      >
      <b-button
        v-for="(t, index) in o_selected"
        :key="index"
        size="sm"
        class="m-1"
        variant="outline-primary"
        @click="deselect(o_selected, i)"
        ><i class="fa fa-close"></i> {{ t }}</b-button
      >
      <b-button
        v-for="(t, index) in t_selected"
        :key="index"
        size="sm"
        class="m-1"
        variant="outline-primary"
        @click="deselect(t_selected, i)"
        ><i class="fa fa-close"></i> {{ t }}</b-button
      >

      <b-button size="sm" class="m-1" variant="primary" @click="deselectall()"
        ><i class="fa fa-close"></i> Clear all</b-button
      >
    </div>
    <div
      style="margin-left: -30px; margin-right: -30px; margin-top: -30px; margin-bottom: 0px;"
    >
      <gmap-map ref="gmap" :center="centerOn" :zoom="zoom" :style="style">
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <b-row
            v-for="focus in focusContent"
            style="min-width: 600px"
            :key="focus"
          >
            <b-col sm="1" v-bind:class="classObject">
              {{ focus.header[7] }} Register
            </b-col>
            <b-col sm="11">
              <img
                :src="getLogoUrl(focus.header[0])"
                style="max-height: 100px"
              />
              <hr />
              <div>
                <h6>{{ focus.header[1] }}</h6>
              </div>
              <div>
                <h6>{{ focus.header[2] }}</h6>
              </div>
              <div v-html="focus.header[4]"></div>

              <div style="padding-top:3px">
                <a :href="focus.header[3]" target="_blank">Visit Website</a>
              </div>
              <hr />

              <div v-for="(m, index) in focus.charts" :key="m">
                <b-row>
                  <b-col sm="9">
                    <div style="font-size: 1.1em; padding-bottom: 15px">
                      <div class="h6" style="text-align: center">
                        {{ m.type }}
                      </div>
                      <div>
                        Total registered primary implants over time:
                        <span class="h6">{{ m.implants.total }}</span>
                      </div>
                    </div>

                    <div class="chart-wrapper">
                      <line-example
                        :id="index"
                        style="height: 200px"
                        :years="m.implants.data"
                        :revisions="m.revisions.data"
                        :type="m.type"
                      />
                    </div>
                    <div class="mt-4">
                      Revision Completeness Rate in %:
                      <span class="h6">{{ m.revisions.coverage }}</span>
                    </div>
                  </b-col>
                  <b-col sm="3">
                    <div style="width: 100%; text-align: center">
                      <img
                        v-show="m.type == 'Hip'"
                        alt="Hip"
                        title="Hip"
                        src="../assets/img/Hip_NORE.jpg"
                        style="max-width: 80px"
                      />
                      <img
                        v-show="m.type == 'Shoulder'"
                        src="../assets/img/Shoulder_NORE.jpg"
                        style="max-width: 80px"
                      />
                      <img
                        v-show="m.type == 'Knee'"
                        alt="Knee"
                        title="Knee"
                        src="../assets/img/Knee_NORE.jpg"
                        style="max-width: 80px"
                      />
                      <img
                        v-show="m.type == 'Ankle'"
                        alt="Ankle"
                        title="Ankle"
                        src="../assets/img/Ankle_NORE.jpg"
                        style="max-width: 80px"
                      />
                    </div>
                    <div
                      style="width: 100%; text-align: center; padding-top: 10px"
                    >
                      <img
                        src="../assets/img/completeness.png"
                        alt="Completeness rate in %"
                        title="Completeness rate in %"
                        style="max-width: 50px"
                      />
                      <div class="h6" style="font-size: 1.0em">
                        {{ m.implants.coverage }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <hr />
              </div>
            </b-col>
          </b-row>
        </gmap-info-window>

        <gmap-cluster :maxZoom="maxZoom" :minimumClusterSize="1">
          <gmap-marker
            v-for="(m, index) in markers"
            :key="index"
            :position="m.position"
            label=""
            :title="m.title"
            :clickable="true"
            :draggable="m.draggable"
            :icon="toggleInfoIcon(m)"
            @click="toggleInfoWindow(m, index)"
          ></gmap-marker>
        </gmap-cluster>
      </gmap-map>
    </div>

    <b-modal
      title="Disclaimer"
      size="lg"
      v-model="filterModal"
      ok-only
      ok-variant="secondary"
      @ok="search"
      @cancel="cancel"
    >
      The information on this Register map is based on data from the registry
      websites. In case a mistake is noticed, please send an email to
      <strong><a href="mailto:nore@efort.org">nore@efort.org</a></strong> attn
      Prof Rob Nelissen.
    </b-modal>
  </div>
</template>

<style>
html,
body {
  height: 100%;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
.register-type {
  color: white;
  padding: 8px;
  min-height: 400px;
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.register-national {
  background-color: #217143;
}

.register-regional {
  background-color: #dc812c;
}

.register-institutional {
  background-color: #35548c;
}
</style>

<script>
//import data from "../router/data";
import library from "../router/library";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import LineExample from "../views/charts/LineExample";

Vue.component("GmapCluster", GmapCluster);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDceZo72DwUrCB5b-O--X7ZaF8cCENTkYY",
    libraries: "places"
    // To use the Google Maps JavaScript API, you must register your app project on the Google API Console and get a Google API key which you can add to your app
    // v: 'OPTIONAL VERSION NUMBER',
    // libraries: 'places', //// If you need to use place input
  }
});

export default {
  name: "DefaultContainer",
  components: {
    LineExample
  },
  data() {
    return {
      centerOn: { lat: 46.4489061, lng: 10.1942073 },
      maxZoom: 0,
      zoom: 4.0,
      index: 0,
      address: {},
      geocoder: null,
      markers: [],
      library: [],
      infoLink: "",
      infoWinOpen: false,
      currentMidx: null,
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      style: "width: 100%; height: 1000px;",
      r: {},
      temp: {},
      datacount: 0,
      g_selected: [],
      o_selected: [],
      t_selected: [],
      g_options: [
        { text: "Education", value: "Education" },
        { text: "Biomechanics", value: "Biomechanics" },
        {
          text: "Implants, Biomaterials & Registry Study",
          value: "Implants, Biomaterials & Registry Study"
        },
        { text: "Basic Sciences", value: "Basic Sciences" },
        { text: "Systemic Disorders", value: "Systemic Disorders" }
      ],
      o_options: [
        { text: "Elbow & Forearm", value: "Elbow & Forearm" },
        { text: "Foot & Ankle", value: "Foot & Ankle" },
        { text: "Knee & Lower Leg", value: "Knee & Lower Leg" },
        {
          text: "Musculoskeletal Infections",
          value: "Musculoskeletal Infections"
        },
        { text: "Musculoskeletal Tumors", value: "Musculoskeletal Tumors" },
        { text: "Paediatric Orthopaedics", value: "Paediatric Orthopaedics" },
        { text: "Pelvis, Hip & Femur", value: "Pelvis, Hip & Femur" },
        { text: "Shoulder & Upper Arm", value: "Shoulder & Upper Arm" },
        { text: "Spine", value: "Spine" },
        { text: "Wrist & Hand", value: "Wrist & Hand" }
      ],
      t_options: [
        { text: "Knee & Lower Leg Trauma", value: "Knee & Lower Leg Trauma" },
        { text: "Elbow & Forearm Trauma", value: "Elbow & Forearm Trauma" },
        { text: "Foot & Ankle Trauma", value: "Foot & Ankle Trauma" },
        { text: "Hand & Wrist Trauma", value: "Hand & Wrist Trauma" },
        { text: "Hip & Femur Trauma", value: "Hip & Femur Trauma" },
        { text: "Paediatric Trauma", value: "Paediatric Trauma" },
        {
          text: "Shoulder & Upper Arm Trauma",
          value: "Shoulder & Upper Arm Trauma"
        },
        { text: "Spine Trauma", value: "Spine Trauma" },
        { text: "Varia Trauma", value: "Varia Trauma" }
      ],
      filterModal: true,
      filterPath: "/nore/map-all",
      filterTerm: "",
      failed: [],
      years: [],
      infoContent: "",
      focusContent: [],
      focusType: "",
      focusMarkers: []
    };
  },
  methods: {
    getLogoUrl(id) {
      return "/nore-map/img/logos/" + id + ".jpg";
    },
    focusOn(what) {
      if (what == "search") {
        this.filterModal = !this.filterModal;
        this.filterPath = "/nore/map-all";
      } else {
        this.filterPath = "/nore/map-" + what;

        if (what == "all") {
          this.filter("");
          this.filterTerm = "";
        } else {
          this.filter(what);
          this.filterTerm = what;
        }
      }
    },
    pushNumber: function(marker, index, years) {
      var n = 0;
      try {
        n = Number(marker[index]);
      } catch (e) {
      } finally {
      }

      if (isNaN(n)) {
        years.push(null);
      } else {
        years.push(n);
      }
    },
    toggleInfoIcon: function(marker) {
      if (marker.data[7] == "Regional") {
        return { url: require("../assets/img/regional.png") };
      }

      if (marker.data[7] == "Institutional") {
        return { url: require("../assets/img/institutional.png") };
      }

      return { url: require("../assets/img/national.png") };
    },
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;

      this.infoContent = marker.data;

      this.focusMarkers = [];
      this.focusMarkers = this.getRelated(this.infoContent);

      this.focusContent = [];
      this.focusContent.push({
        header: this.infoContent,
        charts: this.focusMarkers,
        points: marker.points
      });

      if (this.infoContent[0] == 3) {
        var m = this.getById(4);
        if (m != null)
          this.focusContent.push({ header: m, charts: this.getRelated(m) });
      }

      if (this.infoContent[0] == 4) {
        var m = this.getById(3);
        if (m != null)
          this.focusContent.push({ header: m, charts: this.getRelated(m) });
      }

      this.focusType = this.infoContent[7];

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.currentMidx = idx;
        this.infoWinOpen = true;
      }
    },
    getRelated: function(marker) {
      var related = [];

      for (var i = 0; i < this.markers.length; i++) {
        if (this.markers[i].data[0] == marker[0]) {
          related.push(this.markers[i].points);
        }
      }

      return related;
    },
    getById: function(id) {
      for (var i = 0; i < this.markers.length; i++) {
        if (this.markers[i].data[0] == id) {
          return this.markers[i].data;
        }
      }
      return null;
    },
    getYears: function(marker) {
      var years = [];
      this.pushNumber(marker, 9, years);
      this.pushNumber(marker, 10, years);
      this.pushNumber(marker, 11, years);
      this.pushNumber(marker, 12, years);
      this.pushNumber(marker, 13, years);
      this.pushNumber(marker, -1, years);

      return years;
    },
    getRevisionYears: function(marker) {
      var years = [];
      this.pushNumber(marker, 17, years);
      this.pushNumber(marker, 18, years);
      this.pushNumber(marker, 19, years);
      this.pushNumber(marker, 20, years);
      this.pushNumber(marker, 21, years);
      this.pushNumber(marker, -1, years);

      return years;
    },
    geocode1: function() {
      var loc = "";

      if (this.index < this.datacount) {
        loc = data[this.index][2];
        alert(loc);
      }
    },
    geocode: function() {
      var loc = "";
      if (this.index < this.datacount) {
        loc = data[this.index][4];
      } else {
        return;
      }

      this.$store
        .dispatch("address", {
          key: "AIzaSyDceZo72DwUrCB5b-O--X7ZaF8cCENTkYY",
          address: loc
        })
        .then(
          response => {
            // Commit in vuex
            this.address = response.data.results;

            if (Array.isArray(this.address)) {
              for (var i = 0; i < /*this.address.length*/ 1; i++) {
                if (this.address[i]) {
                  var coordinates = this.address[i].geometry.location;

                  // var l = {position: {lat: coordinates.lat, lng: coordinates.lng}, label: 'FP', draggable: false, title: '', www: ''};
                  // this.markers.push(l);

                  this.library.push({
                    array: data[this.index],
                    position: coordinates
                  });
                } else {
                  this.failed.push(loc);
                }
              }
            }

            this.index++;
            this.geocode();
          },
          error => {
            // Log the error

            console.error(error);
          }
        );
    },
    getCenter: function(country) {
      this.$store
        .dispatch("address", {
          key: "AIzaSyDceZo72DwUrCB5b-O--X7ZaF8cCENTkYY",
          address: country
        })
        .then(
          response => {
            // Commit in vuex
            this.temp = response.data.results[0];
            // this.centerOn = this.temp.geometry.location;
            //

            const bounds = new google.maps.LatLngBounds();
            bounds.extend(this.temp.geometry.bounds.northeast);
            bounds.extend(this.temp.geometry.bounds.southwest);
            this.$refs.gmap.$mapObject.fitBounds(bounds);
          },
          error => {
            // Log the error

            console.error(error);
          }
        );
    },
    search: function() {},
    cancel: function() {},
    inSelection: function(array, topic) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] == topic) return true;
      }
      return false;
    },
    inTopic: function(topic) {
      if (
        this.g_selected.length > 0 ||
        this.o_selected.length > 0 ||
        this.t_selected.length > 0
      ) {
        return (
          this.inSelection(this.g_selected, topic) ||
          this.inSelection(this.o_selected, topic) ||
          this.inSelection(this.t_selected, topic)
        );
      }
      return true;
    },
    inLocation: function(dataArray, location) {
      var country = dataArray[4].toLowerCase();

      return country == location;
    },
    filter: function(term) {
      this.infoWinOpen = false;

      var keyword = term.toLowerCase().replace(/-/g, " ");
      this.markers = [];

      const bounds = new google.maps.LatLngBounds();

      for (var i = 0; i < library.length; i++) {
        var type = library[i].array[8].toLowerCase();

        if (keyword == "" || keyword == "europe" || type == keyword) {
          var coordinates = library[i].position;
          var info = library[i].array;
          var points = library[i].points;
          var l = {
            position: { lat: coordinates.lat, lng: coordinates.lng },
            label: "FP",
            draggable: false,
            title: info[2],
            www: "",
            data: info,
            points: points
          };
          this.markers.push(l);

          bounds.extend(coordinates);
        }
      }

      if (this.markers.length < 2) {
        this.getCenter(keyword);
      } else {
        this.$refs.gmap.$mapObject.fitBounds(bounds);
      }
    },
    deselect: function(array, index) {
      array.splice(index, 1);
      this.focusOn(this.filterTerm);
    },
    deselectall: function() {
      this.g_selected.splice(0);
      this.o_selected.splice(0);
      this.t_selected.splice(0);
      this.focusOn(this.filterTerm);
    },
    select: function(selected, options) {
      selected.splice(0, selected.length);
      for (var i = 0; i < options.length; i++) {
        selected.push(options[i].value);
      }
    },
    adjustPort: function() {
      this.$refs.gmap.$mapPromise.then(map => {
        var bounds = new google.maps.LatLngBounds();

        for (var i = 0; i < library.length; i++) {
          var coordinates = library[i].position;
          bounds.extend(coordinates);
        }

        this.$refs.gmap.$mapObject.fitBounds(bounds);
      });
    }
  },
  mounted: function() {
    let h =
      document.body.scrollHeight - window.innerHeight - document.body.scrollTop;

    var doGeocode = false;

    this.index = 0;
    let height = this.$refs.mapdiv.clientHeight - h;

    this.style = "width: 100%; height: " + height + "px;";

    /*
    if (Array.isArray(data) && doGeocode) {
      this.datacount = data.length;
      this.geocode();
    } */

    if (Array.isArray(library) && !doGeocode) {
      for (var i = 0; i < library.length; i++) {
        var coordinates = library[i].position;
        var info = library[i].array;
        var points = library[i].points;
        var _v = Math.floor(Math.random() * 2) == 1 ? 1 : -1;
        var _d = Math.random() * _v * 0.0001;

        coordinates.lat = coordinates.lat + _d;
        coordinates.lng = coordinates.lng + _d;

        if (info.length == 23) {
          info.push(this.getYears(info));
        }
        if (info.length == 24) {
          info.push(this.getRevisionYears(info));
        }
        //

        var l = {
          position: { lat: coordinates.lat, lng: coordinates.lng },
          label: "",
          draggable: false,
          title: info[2],
          www: "",
          data: info,
          points: points
        };
        this.markers.push(l);
      }
    }

    this.adjustPort();
  },
  computed: {
    classObject: function() {
      return {
        "register-national": this.focusType == "National",
        "register-regional": this.focusType == "Regional",
        "register-institutional": this.focusType == "Institutional",
        "register-type": true
      };
    }
  },
  watch: {
    $route(to, from) {
      if (to.params) {
        this.r = to.params.pathMatch;
        this.focusOn(to.params.pathMatch);
      }
    }
  }
};
</script>
